





























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class TextInput extends Vue {
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
  @Prop({ type: Boolean, default: false }) hasError!: boolean;
  @Prop({ type: Boolean, default: false }) passwordReveal!: boolean;
  @Prop({ type: String, default: "" }) errorMessage!: string;
  @Prop({ type: String, default: "" }) icon!: string;
  @Prop({ type: String, default: "" }) placeholder!: string;
  @Prop({ type: String, default: "text" }) type!: string;
  @Prop({ type: String, default: false }) value!: string;

  $refs!: {
    inputElement: HTMLInputElement;
  };

  hasFocus: boolean = false;
  shouldRevealPassword: boolean = false;

  get inputType(): string {
    if (this.shouldRevealPassword) {
      return "text";
    }

    return this.type;
  }

  get inputValue(): string {
    return this.value;
  }

  set inputValue(newInputValue: string) {
    this.$emit("input", newInputValue);
  }

  takeFocus() {
    this.$refs.inputElement.focus();
  }
}
